import { Column } from '../types';

export const getColumnDisplayValue = (value: any, col: any, depth = 0): string => {
    if (depth > 10) return '';
    if (value === null || value === undefined || value === '') return '';
    if (Array.isArray(value)) return '';
    if (typeof value !== 'object') return String(value);

    const targetCol = col?.targetColumn?.columnName;
    if (targetCol && value[targetCol] !== undefined) {
        const resolved = value[targetCol];
        return typeof resolved === 'object' && resolved !== null
            ? (resolved.name || resolved.id || '')
            : String(resolved);
    }

    const relatedCols = col?.relatedScreen?.columns
        ?.filter((c: any) => !c.screenHidden)
        .sort((a: any, b: any) => a.sortOrder - b.sortOrder) || [];

    const parts: string[] = [];
    for (const rc of relatedCols) {
        const nested = value[rc.code];
        if (nested === null || nested === undefined || nested === '' || Array.isArray(nested)) continue;
        if (typeof nested !== 'object') { parts.push(String(nested)); continue; }
        const resolved = getColumnDisplayValue(nested, rc, depth + 1);
        if (resolved) parts.push(resolved);
    }
    if (parts.length > 0) return parts.join(' | ');
    return value.name || value.id || '';
};

export const getVisibleColumns = (columns: Column[] | undefined | null): Column[] => {
    if (!columns) return [];
    return columns
        .filter((col: any) => !col.screenHidden)
        .sort((a: any, b: any) => a.sortOrder - b.sortOrder);
};

/**
 * Short label for a picked row: the screen's first visible column only.
 *
 * A picker screen usually carries more than a name (a computed "is it free?"
 * flag, a price), and joining all of them turns a chip into "P3 (KE 208 KD) |
 * true". The first column is the one the screen leads with, so it is what
 * names the record. Later columns are used only if the first ones are empty,
 * so a chip is never blank.
 */
export const getRowLabel = (row: any, columns: Column[] | undefined | null): string => {
    if (!row || !columns) return '';
    for (const col of getVisibleColumns(columns)) {
        const display = getColumnDisplayValue(row[col.code], col);
        if (display) return display;
    }
    return '';
};

export const getRowDisplayValue = (row: any, columns: Column[] | undefined | null): string => {
    if (!row || !columns) return '';
    const visible = getVisibleColumns(columns);
    const parts: string[] = [];
    for (const col of visible) {
        const v = row[col.code];
        const display = getColumnDisplayValue(v, col);
        if (display) parts.push(display);
    }
    return parts.join(' | ');
};